import script from "./device-parameter.vue?vue&type=script&setup=true&lang=js"
export * from "./device-parameter.vue?vue&type=script&setup=true&lang=js"

import "./device-parameter.vue?vue&type=style&index=0&id=7ce7b178&lang=scss&scoped=true"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ce7b178"]])

export default __exports__